import { favoriteService } from '@/services/favorites.service';
import { useQuery, useMutation } from '@tanstack/react-query';
import { FavListParams } from '@/types/favorites';

export const useQueryFavoritesList = (favListParams: FavListParams) => {
  const { pageNumber, pageSize, simpleSearchStr } = favListParams;
  return useQuery({
    queryKey: ['FAVORITES_LIST', pageNumber, pageSize, simpleSearchStr],
    queryFn: async () => {
      const data = await favoriteService.getFavoriteList(favListParams);
      return data;
    },
  });
};
export const useMutationAddToFav = () => {
  return useMutation({
    mutationFn: (catalogNumbers: string | string[]) => favoriteService.addToFavorite(catalogNumbers),
  });
};
export const useMutationDeleteFav = () => {
  return useMutation({
    mutationFn: (catalogNumbers: string | string[]) => favoriteService.removeFavorite(catalogNumbers),
  });
};
export const useMutationAddToCart = () => {
  return useMutation({
    mutationFn: (catalogNumbers: string | string[]) => favoriteService.addToCartFavorite(catalogNumbers),
  });
};
export const useMutationCheckFav = () => {
  return useMutation({
    mutationFn: (catalogNumbers: string | string[]) => favoriteService.checkFavorite(catalogNumbers),
  });
};
